import {post} from "./base";

export function getAll(accessToken) {
  return post("campioni/GetCampioni", {accessToken});
}

export function getCampioniByUserTargets(accessToken) {
  return post("campioni/GetCampioniByUserTargets", { accessToken });
}

export async function add(data) {
  // data: FormData -> remember to add accessToken
  await post("campioni/AddCampione", {accessToken: data['accessToken'], formBody: data});
  console.log(`Campione ${data['id']} added`);
}
export async function remove(accessToken, idCampione) {
  await post("campioni/DeleteCampione", {jsonBody: {accessToken, idCampione}});
  console.log(`Campione ${idCampione} deleted`);
}

export async function setAvailability(accessToken, idCampione, value) {
  await post("campioni/UpdateAvailability", {jsonBody: {
    accessToken, 
    id: idCampione, 
    available: value,
  }});
  console.log(`Campione ${idCampione} set as ${value ? 'available' : 'unavailable'}`);
}
